import { render, staticRenderFns } from "./membershipRecord.vue?vue&type=template&id=16d50668&"
import script from "./membershipRecord.vue?vue&type=script&lang=ts&"
export * from "./membershipRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "membershipRecord.vue"
export default component.exports